var map = {
	"./01_maska_mazok_1.svg": 716,
	"./02_maska_krug_1.svg": 717,
	"./03_maska_krug_2.svg": 718,
	"./04_maska_mazok_2.svg": 719,
	"./05_maska_pyatno_1.svg": 720,
	"./06_maska_romb_1.svg": 721,
	"./07_maska_pyatno_2.svg": 722,
	"./08_maska_mazok_3.svg": 723,
	"./09_maska_4-kvadrata.svg": 724,
	"./10_maska_setka-vypuklaya.svg": 725,
	"./11_maska_5-ugol.svg": 726,
	"./12_maska_shit.svg": 727,
	"./13_maska_kniga.svg": 728,
	"./14_maska_shesterenka.svg": 729,
	"./15_maska_klever.svg": 730,
	"./16_maska_klen.svg": 731,
	"./17_maska_kot.svg": 732,
	"./18_maska_serdce.svg": 733,
	"./19_maska_vog-kvadrat.svg": 734,
	"./20_maska_kvadrat-ten.svg": 735,
	"./21_maska_kvadrat-shtrih.svg": 736,
	"./22_maska_kvadrat-skruglenny.svg": 737,
	"./art-bg-carousel-container.png": 763,
	"./badge-fifty.jpg": 756,
	"./badge-icon.svg": 715,
	"./badge-isi2025.jpg": 757,
	"./badge-month.jpg": 758,
	"./badge.jpg": 759,
	"./bg-carousel-container.png": 762,
	"./category-header-preview.png": 765,
	"./countries/ad.png": 766,
	"./countries/ae.png": 767,
	"./countries/af.png": 768,
	"./countries/ag.png": 769,
	"./countries/ai.png": 770,
	"./countries/al.png": 771,
	"./countries/am.png": 772,
	"./countries/ao.png": 773,
	"./countries/aq.png": 774,
	"./countries/ar.png": 775,
	"./countries/as.png": 776,
	"./countries/at.png": 777,
	"./countries/au.png": 778,
	"./countries/aw.png": 779,
	"./countries/ax.png": 780,
	"./countries/az.png": 781,
	"./countries/ba.png": 782,
	"./countries/bb.png": 783,
	"./countries/bd.png": 784,
	"./countries/be.png": 785,
	"./countries/bf.png": 786,
	"./countries/bg.png": 787,
	"./countries/bh.png": 788,
	"./countries/bi.png": 789,
	"./countries/bj.png": 790,
	"./countries/bl.png": 791,
	"./countries/bm.png": 792,
	"./countries/bn.png": 793,
	"./countries/bo.png": 794,
	"./countries/bq.png": 795,
	"./countries/br.png": 796,
	"./countries/bs.png": 797,
	"./countries/bt.png": 798,
	"./countries/bv.png": 799,
	"./countries/bw.png": 800,
	"./countries/by.png": 801,
	"./countries/bz.png": 802,
	"./countries/ca.png": 803,
	"./countries/cc.png": 804,
	"./countries/cd.png": 805,
	"./countries/cf.png": 806,
	"./countries/cg.png": 807,
	"./countries/ch.png": 808,
	"./countries/ci.png": 809,
	"./countries/ck.png": 810,
	"./countries/cl.png": 811,
	"./countries/cm.png": 812,
	"./countries/cn.png": 813,
	"./countries/co.png": 814,
	"./countries/cr.png": 815,
	"./countries/cu.png": 816,
	"./countries/cv.png": 817,
	"./countries/cw.png": 818,
	"./countries/cx.png": 819,
	"./countries/cy.png": 820,
	"./countries/cz.png": 821,
	"./countries/de.png": 822,
	"./countries/dj.png": 823,
	"./countries/dk.png": 824,
	"./countries/dm.png": 825,
	"./countries/do.png": 826,
	"./countries/dz.png": 827,
	"./countries/ec.png": 828,
	"./countries/ee.png": 829,
	"./countries/eg.png": 830,
	"./countries/eh.png": 831,
	"./countries/er.png": 832,
	"./countries/es.png": 833,
	"./countries/et.png": 834,
	"./countries/fi.png": 835,
	"./countries/fj.png": 836,
	"./countries/fk.png": 837,
	"./countries/fm.png": 838,
	"./countries/fo.png": 839,
	"./countries/fr.png": 840,
	"./countries/ga.png": 841,
	"./countries/gb-eng.png": 842,
	"./countries/gb-nir.png": 843,
	"./countries/gb-sct.png": 844,
	"./countries/gb-wls.png": 845,
	"./countries/gb.png": 846,
	"./countries/gd.png": 847,
	"./countries/ge.png": 848,
	"./countries/gf.png": 849,
	"./countries/gg.png": 850,
	"./countries/gh.png": 851,
	"./countries/gi.png": 852,
	"./countries/gl.png": 853,
	"./countries/gm.png": 854,
	"./countries/gn.png": 855,
	"./countries/gp.png": 856,
	"./countries/gq.png": 857,
	"./countries/gr.png": 858,
	"./countries/gs.png": 859,
	"./countries/gt.png": 860,
	"./countries/gu.png": 861,
	"./countries/gw.png": 862,
	"./countries/gy.png": 863,
	"./countries/hk.png": 864,
	"./countries/hm.png": 865,
	"./countries/hn.png": 866,
	"./countries/hr.png": 867,
	"./countries/ht.png": 868,
	"./countries/hu.png": 869,
	"./countries/id.png": 870,
	"./countries/ie.png": 871,
	"./countries/il.png": 872,
	"./countries/im.png": 873,
	"./countries/in.png": 874,
	"./countries/io.png": 875,
	"./countries/iq.png": 876,
	"./countries/ir.png": 877,
	"./countries/is.png": 878,
	"./countries/it.png": 879,
	"./countries/je.png": 880,
	"./countries/jm.png": 881,
	"./countries/jo.png": 882,
	"./countries/jp.png": 883,
	"./countries/ke.png": 884,
	"./countries/kg.png": 885,
	"./countries/kh.png": 886,
	"./countries/ki.png": 887,
	"./countries/km.png": 888,
	"./countries/kn.png": 889,
	"./countries/kp.png": 890,
	"./countries/kr.png": 891,
	"./countries/kw.png": 892,
	"./countries/ky.png": 893,
	"./countries/kz.png": 894,
	"./countries/la.png": 895,
	"./countries/lb.png": 896,
	"./countries/lc.png": 897,
	"./countries/li.png": 898,
	"./countries/lk.png": 899,
	"./countries/lr.png": 900,
	"./countries/ls.png": 901,
	"./countries/lt.png": 902,
	"./countries/lu.png": 903,
	"./countries/lv.png": 904,
	"./countries/ly.png": 905,
	"./countries/ma.png": 906,
	"./countries/mc.png": 907,
	"./countries/md.png": 908,
	"./countries/me.png": 909,
	"./countries/mf.png": 910,
	"./countries/mg.png": 911,
	"./countries/mh.png": 912,
	"./countries/mk.png": 913,
	"./countries/ml.png": 914,
	"./countries/mm.png": 915,
	"./countries/mn.png": 916,
	"./countries/mo.png": 917,
	"./countries/mp.png": 918,
	"./countries/mq.png": 919,
	"./countries/mr.png": 920,
	"./countries/ms.png": 921,
	"./countries/mt.png": 922,
	"./countries/mu.png": 923,
	"./countries/mv.png": 924,
	"./countries/mw.png": 925,
	"./countries/mx.png": 926,
	"./countries/my.png": 927,
	"./countries/mz.png": 928,
	"./countries/na.png": 929,
	"./countries/nc.png": 930,
	"./countries/ne.png": 931,
	"./countries/nf.png": 932,
	"./countries/ng.png": 933,
	"./countries/ni.png": 934,
	"./countries/nl.png": 935,
	"./countries/no.png": 936,
	"./countries/np.png": 937,
	"./countries/nr.png": 938,
	"./countries/nu.png": 939,
	"./countries/nz.png": 940,
	"./countries/om.png": 941,
	"./countries/pa.png": 942,
	"./countries/pe.png": 943,
	"./countries/pf.png": 944,
	"./countries/pg.png": 945,
	"./countries/ph.png": 946,
	"./countries/pk.png": 947,
	"./countries/pl.png": 948,
	"./countries/pm.png": 949,
	"./countries/pn.png": 950,
	"./countries/pr.png": 951,
	"./countries/ps.png": 952,
	"./countries/pt.png": 953,
	"./countries/pw.png": 954,
	"./countries/py.png": 955,
	"./countries/qa.png": 956,
	"./countries/re.png": 957,
	"./countries/ro.png": 958,
	"./countries/rs.png": 959,
	"./countries/ru.png": 960,
	"./countries/rw.png": 961,
	"./countries/sa.png": 962,
	"./countries/sb.png": 963,
	"./countries/sc.png": 964,
	"./countries/sd.png": 965,
	"./countries/se.png": 966,
	"./countries/sg.png": 967,
	"./countries/sh.png": 968,
	"./countries/si.png": 969,
	"./countries/sj.png": 970,
	"./countries/sk.png": 971,
	"./countries/sl.png": 972,
	"./countries/sm.png": 973,
	"./countries/sn.png": 974,
	"./countries/so.png": 975,
	"./countries/sr.png": 976,
	"./countries/ss.png": 977,
	"./countries/st.png": 978,
	"./countries/sv.png": 979,
	"./countries/sx.png": 980,
	"./countries/sy.png": 981,
	"./countries/sz.png": 982,
	"./countries/tc.png": 983,
	"./countries/td.png": 984,
	"./countries/tf.png": 985,
	"./countries/tg.png": 986,
	"./countries/th.png": 987,
	"./countries/tj.png": 988,
	"./countries/tk.png": 989,
	"./countries/tl.png": 990,
	"./countries/tm.png": 991,
	"./countries/tn.png": 992,
	"./countries/to.png": 993,
	"./countries/tr.png": 994,
	"./countries/tt.png": 995,
	"./countries/tv.png": 996,
	"./countries/tw.png": 997,
	"./countries/tz.png": 998,
	"./countries/ua.png": 999,
	"./countries/ug.png": 1000,
	"./countries/um.png": 1001,
	"./countries/us.png": 1002,
	"./countries/uy.png": 1003,
	"./countries/uz.png": 1004,
	"./countries/va.png": 1005,
	"./countries/vc.png": 1006,
	"./countries/ve.png": 1007,
	"./countries/vg.png": 1008,
	"./countries/vi.png": 1009,
	"./countries/vn.png": 1010,
	"./countries/vu.png": 1011,
	"./countries/wf.png": 1012,
	"./countries/ws.png": 1013,
	"./countries/xk.png": 1014,
	"./countries/ye.png": 1015,
	"./countries/yt.png": 1016,
	"./countries/za.png": 1017,
	"./countries/zm.png": 1018,
	"./countries/zw.png": 1019,
	"./diff_attr_image_icon.png": 760,
	"./facts-example.png": 1220,
	"./icon_files/about1.png": 646,
	"./icon_files/about2.png": 647,
	"./icon_files/graphics-4829280.png": 648,
	"./illustration-example.png": 1221,
	"./list-example.png": 1222,
	"./logo-vistat-modern-white.svg": 738,
	"./logo-vistat-modern.svg": 739,
	"./logo-vistat-white.png": 714,
	"./logo-vistat.png": 764,
	"./logo-vistat.svg": 740,
	"./masks/01_maska_mazok_1.svg": 669,
	"./masks/02_maska_krug_1.svg": 670,
	"./masks/03_maska_krug_2.svg": 671,
	"./masks/04_maska_mazok_2.svg": 672,
	"./masks/05_maska_pyatno_1.svg": 673,
	"./masks/06_maska_romb_1.svg": 674,
	"./masks/07_maska_pyatno_2.svg": 675,
	"./masks/08_maska_mazok_3.svg": 676,
	"./masks/09_maska_4-kvadrata.svg": 677,
	"./masks/10_maska_setka-vypuklaya.svg": 678,
	"./masks/11_maska_5-ugol.svg": 679,
	"./masks/12_maska_shit.svg": 680,
	"./masks/13_maska_kniga.svg": 681,
	"./masks/14_maska_shesterenka.svg": 682,
	"./masks/15_maska_klever.svg": 683,
	"./masks/16_maska_klen.svg": 684,
	"./masks/17_maska_kot.svg": 685,
	"./masks/18_maska_serdce.svg": 686,
	"./masks/19_maska_vog-kvadrat.svg": 687,
	"./masks/20_maska_kvadrat-ten.svg": 688,
	"./masks/21_maska_kvadrat-shtrih.svg": 689,
	"./masks/22_maska_kvadrat-skruglenny.svg": 690,
	"./new-logo-64.png": 1223,
	"./new-logo-full.png": 324,
	"./new-logo.png": 1224,
	"./objects-links-bg-2.jpeg": 750,
	"./objects-links-bg-3.png": 751,
	"./objects-links-bg-default.jpeg": 752,
	"./objects-links-info.webp": 742,
	"./polygon-view-anchor.png": 1225,
	"./user-avatar-bg.jpg": 746,
	"./voronoy-static-white.png": 1226,
	"./voronoy-static-white.webp": 704,
	"./yandex.png": 747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1219;